import { clientHttp } from '@/common/http';
import {
  GetPersonalizedStoreItemsApi,
  getPersonalizedStoreItemsInputSchema,
  getPersonalizedStoreItemsResponseSchema,
} from './get-personalized-store-items';

export const getPersonalizedStoreItems: GetPersonalizedStoreItemsApi = async ({
  input,
  headers,
  signal,
}) => {
  try {
    const params = getPersonalizedStoreItemsInputSchema.parse(input);
    const searchParams = new URLSearchParams();
    searchParams.set('userId', String(params.userId));

    if (params.isLoggedIn) {
      searchParams.set('isLoggedIn', 'true');
    }

    if (params.showCouponBadge) {
      searchParams.set('showCouponBadge', 'true');
    }

    const json = await clientHttp
      .get(
        `/api/promotions/store-items/personalized?${searchParams.toString()}`,
        { headers, signal },
      )
      .json();
    return getPersonalizedStoreItemsResponseSchema.parse(json);
  } catch {
    return {
      items: [],
    };
  }
};
